<template>

  <div class="container-fluid">

    <!-- Estado de carga -->
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
      <p>Cargando...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5">
      <div class="alert alert-danger">
        <h5>Error al cargar los datos</h5>
        <p>{{ error.message || 'Ocurrió un error inesperado' }}</p>
        <button class="btn btn-primary" @click="fetchAll()">Reintentar</button>
      </div>
    </div>

    <!-- Contenido -->
    <div v-else>

      <!-- Tarjeta de introducción -->
      <div v-if="pageData" class="row">
        <div class="col-sm-12 col-lg-12 mt-3">
          <div class="card">
            <div class="card-header">
              <h5><vue-feather type="map"></vue-feather> {{ pageData.title }}</h5>
            </div>
            <div class="card-body">
              <div v-if="pageData.body" v-html="pageData.body"></div>
              <div v-else-if="pageData.intro" v-html="pageData.intro"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Matriz de tarjetas por estado -->
      <div v-if="estados && estados.length" class="row starter-main mt-3">
        <div class="col-sm-12 col-lg-4 mb-4" v-for="post in estados" :key="post.id">
          <div class="card h-100">
            <router-link :to="{ name: 'fichaEstatal', params: { idestado: post.id } }">
              <img
                v-if="post.thumbnail_rendition"
                :src="post.thumbnail_rendition.full_url"
                :alt="post.thumbnail_rendition.alt"
                class="card-img-top"
                style="object-fit: contain; max-height: 160px; padding: 1rem; cursor: pointer;"
              />
            </router-link>
            <div class="card-body">
              <h5 class="text-center">{{ post.title }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!-- Reportes de metas - Looker-->
      <div class="container-fluid">
        <div class="row mt-3">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header p-0 border-bottom-0" style="background: #f8f9fa;">
                <ul class="nav nav-tabs ficha-tabs px-3 pt-2">
                  <li class="nav-item" v-for="tab in metaTabs" :key="tab.key">
                    <button
                      class="nav-link ficha-tab-btn"
                      :class="{ active: activeMetaTab === tab.key }"
                      @click="activeMetaTab = tab.key; iframeLoading[tab.key] = true"
                    >{{ tab.label }}</button>
                  </li>
                </ul>
              </div>
              <div class="card-body p-0">
                <div
                  v-for="tab in metaTabs"
                  :key="tab.key"
                  v-show="activeMetaTab === tab.key"
                  class="embed-responsive"
                  style="position: relative;"
                >
                  <!-- Spinner de carga -->
                  <div v-if="iframeLoading[tab.key]" class="iframe-loader">
                    <div class="loader-box">
                      <div class="loader-3"></div>
                    </div>
                    <p class="mt-2 text-muted">Cargando reporte, puede tardar varios segundos...</p>
                  </div>
                  <iframe
                    :src="tab.url"
                    frameborder="0"
                    style="border: 0; width: 100%; height: calc(100vh - 200px); min-height: 600px;"
                    allowfullscreen
                    @load="iframeLoading[tab.key] = false"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import api from "@/axios";

export default {
  name: "BajioVerdeIntro",
  data() {
    return {
      pageData: null,
      estados: null,
      error: null,
      loading: true,
      activeMetaTab: 'meta1',
      iframeLoading: {
        meta1: true, meta2: true, meta3: true,
        meta4a: true, meta4b: true, meta5: true, meta6: true,
      },
      metaTabs: [
        { key: 'meta1',  label: 'Meta 1',   url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/Nw4WF' },
        { key: 'meta2',  label: 'Meta 2',   url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_g0j8kujjwd' },
        { key: 'meta3',  label: 'Meta 3',   url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_wxthm4jjwd' },
        { key: 'meta4a', label: 'Meta 4a',  url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_p866q4jjwd' },
        { key: 'meta4b', label: 'Meta 4b',  url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_nfx5u4jjwd' },
        { key: 'meta5',  label: 'Meta 5',   url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_z6bkqqmjwd' },
        { key: 'meta6',  label: 'Meta 6',   url: 'https://lookerstudio.google.com/embed/reporting/370c701c-b42f-480d-a92c-29fdc914d8cc/page/p_yo8cz0mjwd' },
      ],
    };
  },
  created() {
    this.fetchAll();
  },
  methods: {
    async fetchAll() {
      this.loading = true;
      this.error = null;
      try {
        await Promise.all([this.fetchPage(), this.fetchPosts()]);
      } finally {
        this.loading = false;
      }
    },
    async fetchPage() {
      try {
        const { data } = await api.get("pages/48");
        this.pageData = data;
      } catch (err) {
        this.error = err;
        console.error("error en fetchPage", err);
      }
    },
    async fetchPosts() {
      try {
        const { data } = await api.get("blog?child_of=24&fields=intro,thumbnail,thumbnail_rendition&order=first_published_at");
        this.estados = data.items ?? (Array.isArray(data) ? data : [data]);
      } catch (err) {
        this.error = err;
        console.error("error en fetchPosts", err);
      }
    },
  },
};
</script>

<style scoped>
.embed-responsive {
  position: relative;
  width: 100%;
}

.iframe-loader {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  min-height: 300px;
}

.ficha-tab-btn {
  font-size: 0.9rem;
  color: #555;
  border: none;
  border-bottom: 3px solid transparent;
  background: transparent;
  border-radius: 0;
  padding: 0.55rem 1rem;
  margin-right: 4px;
  transition: color 0.2s, border-color 0.2s;
}
.ficha-tab-btn:hover {
  color: #182e50;
  border-bottom-color: #182e50;
  background: transparent;
}
.ficha-tab-btn.active {
  color: #fff !important;
  background-color: #182e50 !important;
  border-color: #182e50 #182e50 #fff !important;
  border-radius: 6px 6px 0 0;
  font-weight: 600;
}
</style>